export default {
  steps: {
    coin: {
      label: 'Coins'
    },
    loyalty: {
      label: 'Loyalty'
    },
    refund: {
      label: 'Refund'
    },
    widget: {
      label: 'Widget'
    }
  },
  welcome: {
    title: '{firstName},<br />welcome to Twism!',
    titleWithoutName: 'Welcome to<br />Twism!',
    subTitle:
      'Quickly set up your reward program<br />with these {stepsAmount} easy steps.',
    ctaButton: "Let's get started",
    stepLabel: 'Step {count}',
    steps: {
      coin: {
        label: 'Upload your logo'
      },
      loyalty: {
        label: 'Setup loyalty ratio'
      },
      refund: {
        label: 'Select refund policy'
      },
      widget: {
        label: 'Customize your widget'
      }
    }
  },
  coin: {
    ilustra: {
      yourCoin: 'Your<br />Coin'
    },
    sellCoins: {
      title: "Let's start with the good stuff!",
      topic: 'Mint your Coin and start unlocking its superpowers.',
      tip: 'This can be changed later.',
      toggle: {
        title: 'Allow members to buy and gift your branded Coins',
        description:
          "Enable people to buy gift Coins, generate upfront cash, and drive more sales. <br />You don't pay a thing unless a Coin is purchased.",
        caption: 'Fees applied per transaction: 5% + $0.30.',
        warning:
          'Are you sure? Members will not be able to buy or gift your branded Coins.'
      }
    },
    explanation: {
      title: "Let's start with loyalty Coins",
      topic: 'Coins are your rewards currency!',
      description:
        'No more punch cards, stars, or confusing points. Your uniquely branded Coins are how you reward your members.<br /><br />Create your Coin in the next step!'
    },
    main: {
      title: 'Create your Coin',
      description:
        'You choose what your Coin will look like! We recommend your <strong>business logo</strong> or <strong>Social media image</strong> so people recognize your brand.',
      cropTitle: 'Logo / Coin Image',
      cropButtonLabelText: 'Upload',
      uploadInstructionLabelMobile: 'Upload an image',
      uploadInstructionLabelDesktop: 'Upload or drag and drop an image'
    }
  },
  loyalty: {
    ilustra: {
      title: 'Reward example • 10%',
      example1: {
        start: 'Lisa spends',
        middle: '{currencySymbol}100',
        end: 'at your business'
      },
      example2: {
        start: 'She will earn',
        middle: '10',
        end: 'Coins'
      },
      example3: {
        start: 'Her Coins are equivalent to a',
        middle: '{currencySymbol}10',
        end: 'discount code on a future purchase'
      }
    },
    setupIlustra: {
      percentSymbol: '%',
      title: 'Reward Recommendations',
      list: [
        {
          info: '5%',
          label: 'for fine dining, high-end & luxury items'
        },
        {
          info: '10%',
          label: 'for quick service food, coffee, e-commerce & retail'
        },
        {
          info: '15%',
          label: 'for businesses wanting to offer bigger rewards'
        },
        {
          info: '20%',
          label: 'for businesses wanting to offer bigger rewards'
        }
      ],
      listDashboardNewBusinessOnboarding: [
        {
          info: '5%',
          label: 'for fine dining, high-end & luxury items'
        },
        {
          info: '7%',
          label: 'for quick service food, coffee, e-commerce & retail'
        },
        {
          info: '12%',
          label: 'for businesses wanting to offer bigger rewards'
        }
      ]
    },
    explanation: {
      title: 'Loyalty Setup',
      description:
        "Every time a member makes a purchase, they will automatically be rewarded with Coins that can be used as payment codes on future purchases.<br /><br />On the next step, you'll choose your reward rate."
    },
    main: {
      title: 'Reward with Coins',
      topic: 'After a purchase, the member will earn:',
      description:
        'Select an option or set a custom value. This can be changed later.'
    }
  },
  refund: {
    ilustra: {
      availableCoins: 'Available Coins',
      pendingCoins: 'Pending Coins'
    },
    main: {
      title: 'Your refund policy',
      topic: 'Select how many days before Coins are activated:',
      description:
        'The Coins will only be activated after your refund period for your protection.<br /><br />Select an option or set a custom time. This can be changed later.'
    }
  },
  widget: {
    explanation: {
      title: 'Website widget',
      description: `Your widget is the small interactive window on your website that
      allows members to engage with your Loyalty Program.
      <br />
      <br />
      It enables members to claim, earn, and use their Loyalty Rewards in
      real-time.
      <br />
      <br />
      The widget is placed on the bottom left side of your website by
      default. In the next step, you can customize its position and color.`
    },
    main: {
      title: ''
    }
  },
  success: {
    title: "{managerName}, you're all set!",
    checkpointTitle: "So far you've completed:",
    checkWebsite: 'Check out your website Widget',
    takeTour: 'Take a tour',
    goToDashboard: 'Go to dashboard',
    firstDescription: `Your rewards program has been <strong>activated</strong>. It
    may take a few days to achieve full transaction coverage.`,
    secondDescription: {
      mobile: `Now for a better experience follow the<br />guided tour that we've
      prepared for you through your computer.`,
      desktop: `Now take a moment and get to know more about your Twism dashboard
      with a <strong>quick guided tour</strong>.`
    }
  }
};
